import { useEffect, useState, useContext } from "react";
import axios from "../api/axios";
import { IAM_SERVER_TENANT, IAM_SERVER_TENANT_USER } from "../Config";
import { AuthContext } from "../contextapi/AuthProvider";

export function useTenantList() {
    const [tenantList, setTenantList] = useState([]);
    const [error, setError] = useState(null);
    const { role, user } = useContext(AuthContext);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchTenantsForProfiles = async () => {
            setIsLoading(true);

            try {
                if (!role || !Array.isArray(role)) {
                    setTenantList([]);
                    return;
                }

                const mergedTenantMap = new Map();

                if (role.includes("SYS_ADMIN")) {
                    const params = {
                        sortField: ["createdDate"],
                        sortOrder: ["asc"],
                        operator: "AND",
                        conditions: [
                            { field: "status", operator: "NOT_EQUALS", value: "pending" }
                        ]
                    };

                    const tenantResponse = await axios.post(IAM_SERVER_TENANT + "/all", params);
                    const adminTenants = tenantResponse?.data?.data?.data || [];

                    adminTenants.forEach((tenant) => {
                        mergedTenantMap.set(tenant.tenantId, tenant);
                    });
                }

                if (role.includes("USER")) {
                    const userProfileList = user?.sub_profile || [];

                    if (userProfileList.length > 0) {
                        const requests = userProfileList.map((profile) =>
                            axios.get(`${IAM_SERVER_TENANT_USER}/get/${profile.profile_id}/tenantUser`)
                        );
                        const responses = await Promise.allSettled(requests);

                        const userTenants = responses
                            .filter((response) => response.status === "fulfilled" && Array.isArray(response.value.data.data))
                            .flatMap((response) => response.value.data.data);

                        userTenants.forEach((tenant) => {
                            const existingTenant = mergedTenantMap.get(tenant.tenantId) || {};

                            mergedTenantMap.set(tenant.tenantId, {
                                ...existingTenant,
                                ...tenant,
                                currentUserPermission: tenant.currentUserPermission || existingTenant.currentUserPermission,
                            });
                        });
                    }
                }

                setTenantList(Array.from(mergedTenantMap.values()));
            } catch (err) {
                console.error("?뚮꼳??議고쉶 以??ㅻ쪟:", err);
                setError(err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchTenantsForProfiles();
    }, [role, user]);

    return { tenantList, isLoading, error };
}
